import * as React from 'react';
import styled from 'styled-components';
import { Divider } from '../Divider';

export function SeparatorMenuItem():JSX.Element
{
    return (
        <MenuItemDividerStyle>
            <Divider />
        </MenuItemDividerStyle>
    );
}

const MenuItemDividerStyle = styled.div`
    padding: 4px 12px;

`